import React, { useEffect, useState, useRef } from "react";

const Map = ({ onMarkerAdded, radius, lat, lng, zoom, petDet, height }) => {
  const [circle, setCircle] = useState(null);
  const [circleRadius, setCircleRadius] = useState(radius);
  const [location, setLocation] = useState(null);
  const mapDivRef = useRef(null);
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
  if (mapRef.current && !mapInstanceRef.current) {
    // Inicializar mapa
    mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
      center: { lat: Number(lat) || -34.9011, lng: Number(lng) || -56.1645 },
      zoom: zoom || 13,
    });

    // Usar PlaceAutocompleteElement en lugar de Autocomplete
    if (!petDet) {
      const input = document.getElementById('pac-input');
      
      // Nueva forma recomendada
      const autocompleteElement = new window.google.maps.places.PlaceAutocompleteElement({
        componentRestrictions: { country: 'uy' }, // o el país que necesites
      });
      
      autocompleteElement.addEventListener('gmp-placeselect', async ({ place }) => {
        if (place.geometry && place.geometry.location) {
          const newLat = place.geometry.location.lat();
          const newLng = place.geometry.location.lng();
          onMarkerAdded(newLat, newLng);
        }
      });

      // Agregar al DOM
      if (input) {
        input.parentNode.replaceChild(autocompleteElement, input);
      }
    }
  }
}, [lat, lng, zoom, petDet, onMarkerAdded]);

  useEffect(() => {
    let map;
    let marker;

    async function initMap() {
      const google = window.google;
      const { Map } = await google.maps.importLibrary("maps");

      const defaultLat = -34.856644;
      const defaultLng = -56.17596;
      const validLat =
        (typeof lat === "string" ? parseFloat(lat) : lat) || defaultLat;
      const validLng =
        (typeof lng === "string" ? parseFloat(lng) : lng) || defaultLng;

      map = new Map(document.getElementById("map"), {
        center: { lat: validLat, lng: validLng },
        zoom: zoom || 10,
        streetViewControl: false,
      });

      if (validLat !== defaultLat || validLng !== defaultLng) {
        addMarker(new google.maps.LatLng(validLat, validLng));
      }

      map.addListener("click", (event) => {
        if (!petDet) {
          const { lat, lng } = event.latLng.toJSON();
          addMarker(event.latLng);
          onMarkerAdded(lat, lng);
        }
      });
    }

    const addMarker = (location) => {
      if (!marker) {
        marker = new window.google.maps.Marker({
          position: location,
          map: map,
        });
        const radiusNumber = !isNaN(parseInt(circleRadius))
          ? parseInt(circleRadius)
          : 0;
        // eslint-disable-next-line no-undef
        const newCircle = new google.maps.Circle({
          map: map,
          center: location,
          radius: radiusNumber,
          strokeColor: "#111",
          strokeOpacity: 0.3,
          strokeWeight: 1,
          fillColor: "#FFFFFF",
          fillOpacity: 0.35,
        });
        setCircle(newCircle);
      } else {
        marker.setPosition(location);
      }
      setLocation(location);
    };

   if  (mapDivRef.current) {
      initMap();
    }
  }, [onMarkerAdded, lat, lng, zoom]);

  useEffect(() => {
    if (circle && circleRadius) {
      const radiusNumber = !isNaN(parseInt(circleRadius))
        ? parseInt(circleRadius)
        : 0;
      circle.setRadius(radiusNumber);
      circle.setCenter(location);
    }
  }, [circle, circleRadius, location]);

  useEffect(() => {
    setCircleRadius(radius);
  }, [radius]);

  return (
    <div>
      <div ref={mapDivRef} id="map" className='w-full' style={{ height: height || 'auto' }} ></div>
    </div>
  );
};

export default Map;
